////////////////////////////////////////////////////////
/////// Blog
////////////////////////////////////////////////////////

var InfiniteScroll = require('infinite-scroll');

$(document).ready(function () {

	if (!$('.tx-blog-post-list').length) {
		return;
	}
	$(document).on('click', '#load-more', function(e) {
		e.preventDefault();
	});
	var infScroll = new InfiniteScroll('.load-more-pagination', {
		path: function() {
			var nextHref = $('.load-more-pagination-container').last().data('next');
			if (!nextHref) {
				return false;
			}
			return nextHref + '&type=2000';
		},
		append: '.load-more-pagination',
		button: '#load-more',
		scrollThreshold: false,
		history: false,
		checkLastPage: '.load-more-pagination-container',
		status: '.page-load-status'
	});

});